import { z } from 'zod';

export const streamServeProjektErstellenSchema = z.object({
  projektName: z.string().trim().min(1, 'Projektname ist Pflicht.').max(100),
  projektVersion: z
    .number({ message: 'Projekt-Version muss eine Ganzzahl sein.' })
    .int('Projekt-Version muss eine Ganzzahl sein.')
    .min(0, 'Projekt-Version darf nicht negativ sein.'),
});

export type StreamServeProjektFormValues = z.infer<
  typeof streamServeProjektErstellenSchema
>;

export const DEFAULT_STREAMSERVE_PROJEKT_FORM_VALUES: StreamServeProjektFormValues =
  {
    projektName: '',
    projektVersion: 0,
  };
